import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BaseRegistrationFormComponent } from '../base-registration-form/base-registration-form.component';
import { SiteService } from '../../../services/data/site.service';
import { CountryService } from '../../../services/data/country.service';
import { EnumTranslationService } from '../../../services/enum-translation.service';
import { getCompanyInformationSection, getPassportSection, getPersonalInformationSection, getRegistrationFormHeader, reasonForVisitSection, getRequiredDocumentationSection, sipsiCertificateSection, workPermitSection, workVisaSection, getEHSSection } from '../base-registration-form/form-field-config';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormlyDateSelectionComponent } from '../../formly/formly-date-selection/formly-date-selection.component';
import { FormlyFileSelectionComponent } from '../../formly/formly-file-selection/formly-file-selection.component';
import { VisitorRegistrationFormType } from '../../../models/visitor-registration-form-type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-short-term-assignment-form',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    TranslateModule,
    NgbTooltipModule,
    NgbDropdownModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    FormlyDateSelectionComponent,
    FormlyFileSelectionComponent,
  ],
  templateUrl: './short-term-assignment-form.component.html',
  styleUrl: './short-term-assignment-form.component.scss'
})
export class ShortTermAssignmentFormComponent extends BaseRegistrationFormComponent implements OnInit {

  constructor(
    siteService: SiteService,
    countryService: CountryService,
    enumTranslationService: EnumTranslationService,
  ) {
    super(VisitorRegistrationFormType.WorkOnSite);

    // Intialize form fields
    this.fields = [
      ...getRegistrationFormHeader(siteService, enumTranslationService),
      ...getPersonalInformationSection(enumTranslationService),
      ...getPassportSection(countryService),
      ...workPermitSection,
      ...workVisaSection,
      ...getCompanyInformationSection(true),
      ...reasonForVisitSection,
      ...sipsiCertificateSection,
      ...getRequiredDocumentationSection(),
      ...getEHSSection()
    ];
  }
}
